module.exports = __webpack_public_path__ + "img/change-data-coupon.0a07e5ea.svg";